import { getProtocol } from '../../../helpers/urlHelpers';

export const openPdf = (file: string) => {
  const protocol = getProtocol();

  window.open(`${protocol}://${localStorage.getItem('apiUrl')}/api/show?name=${file}`, '_blank');
};
